import { createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles(() =>
  createStyles({
    instructionsBox: {
      margin: '0 0 24px'
    },
    inputFieldBox: {
      margin: '0 0 24px'
    }
  })
);
